import { useRef } from 'react'

import styles from './VideoPlayback.module.css'

export interface VimeoInput {
  id: string
  playerUrl: string
  externalUrl?: {
    quality360: string
    quality540: string
    quality720: string
    quality1080: string
    hls: string
  }
  title: string
  duration: string
  createdAt: string
  thumbnailSmall?: string
  thumbnail?: string
  thumbnailPlay?: string
}

export interface VideoPlaybackProps {
  src?: string
  vimeo?: VimeoInput
  testID?: string
  ambientLoop?: boolean
}

export default function VideoPlayback({
  src,
  vimeo,
  testID,
  ambientLoop = false,
}: VideoPlaybackProps) {
  const ref = useRef<HTMLVideoElement>(null)
  const getVimeoSrc = () => {
    const width = ref.current?.clientWidth
    const v = vimeo?.externalUrl
    if (v) {
      if (!width || (width >= 1900 && v.quality1080)) return v.quality1080
      else if (width >= 1200 && v.quality720) return v.quality720
      else if (width >= 900 && v.quality540) return v.quality540
      else return v.quality360
    }
  }

  return (
    <video
      className={styles.base}
      data-testid={testID}
      loop={ambientLoop}
      autoPlay={ambientLoop}
      muted={ambientLoop}
      controls={!ambientLoop}
      ref={ref}
    >
      <source src={src || getVimeoSrc()} />
    </video>
  )
}
